/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_contact_fields_other_subject = /** @type {(inputs: {}) => string} */ () => {
	return `Předmět`
};

const da_contact_fields_other_subject = /** @type {(inputs: {}) => string} */ () => {
	return `Emne`
};

const de_contact_fields_other_subject = /** @type {(inputs: {}) => string} */ () => {
	return `Betreff`
};

const en_contact_fields_other_subject = /** @type {(inputs: {}) => string} */ () => {
	return `Subject`
};

const es_contact_fields_other_subject = /** @type {(inputs: {}) => string} */ () => {
	return `Asunto`
};

const fr_contact_fields_other_subject = /** @type {(inputs: {}) => string} */ () => {
	return `Objet`
};

const hu_contact_fields_other_subject = /** @type {(inputs: {}) => string} */ () => {
	return `Tárgy`
};

const it_contact_fields_other_subject = /** @type {(inputs: {}) => string} */ () => {
	return `Oggetto`
};

const nl_contact_fields_other_subject = /** @type {(inputs: {}) => string} */ () => {
	return `Onderwerp`
};

const pl_contact_fields_other_subject = /** @type {(inputs: {}) => string} */ () => {
	return `Temat`
};

const pt_contact_fields_other_subject = /** @type {(inputs: {}) => string} */ () => {
	return `Assunto`
};

const sv_contact_fields_other_subject = /** @type {(inputs: {}) => string} */ () => {
	return `Ämne`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const contact_fields_other_subject = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.contact_fields_other_subject(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("contact_fields_other_subject", locale)
	if (locale === "cs") return cs_contact_fields_other_subject(inputs)
	if (locale === "da") return da_contact_fields_other_subject(inputs)
	if (locale === "de") return de_contact_fields_other_subject(inputs)
	if (locale === "en") return en_contact_fields_other_subject(inputs)
	if (locale === "es") return es_contact_fields_other_subject(inputs)
	if (locale === "fr") return fr_contact_fields_other_subject(inputs)
	if (locale === "hu") return hu_contact_fields_other_subject(inputs)
	if (locale === "it") return it_contact_fields_other_subject(inputs)
	if (locale === "nl") return nl_contact_fields_other_subject(inputs)
	if (locale === "pl") return pl_contact_fields_other_subject(inputs)
	if (locale === "pt") return pt_contact_fields_other_subject(inputs)
	return sv_contact_fields_other_subject(inputs)
};
export { contact_fields_other_subject as "contact.fields.other_subject" }